// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Checkbox,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Alert
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";

import "../dashboard/dashboard.scss";
import { printSampleVoucher, mapkey} from "../../../redux/actions/frontActions";
import logo from "../../../img/ddb-logo.png";

import { appConfig } from "../../../config";

import { Notification } from "../../../components/notifications";

import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";

import ReactHtmlParser from "react-html-parser";


const history = createBrowserHistory();
let isLoading = "false";
class SampleVoucher extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      show: false,
      voucher: ""
    };

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  Clear() {
    this.setState({
      show: false
    });
  }

  handlePageChange = () =>{
    let dealIDParams = this.props.match.params.dealID ? this.props.match.params.dealID : '';
    if (dealIDParams !== '')
    {
      isLoading="true";
      this.props.printSampleVoucher(dealIDParams);
    }
  };

  componentWillMount() {
    this.props.clearAlert();
    this.handleDismiss();
    this.handlePageChange();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.voucherDetail !== nextProps.voucherDetail) {
      if (nextProps.voucherDetail) {
        isLoading = "false";
        this.setState({ voucher: nextProps.voucherDetail });
      }
    }
  }

  componentWillUpdate(nextProps, nextState) {}

  printDiv = () => {
    let divToPrint = document.getElementById("DivIdToPrint");

    let newWin = window.open("", "Print-Window");

    newWin.document.open();

    newWin.document.write(
      '<html><body onload="window.print()">' +
        divToPrint.innerHTML +
        "</body></html>"
    );

    newWin.document.close();
  };

  render() {
    const style = {
      width: "100%",
      height: "100%"
    };

    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="container">
          <div className="panel margin-top">
            <header className="panel-heading">
              Sample Voucher{" "}
              <Button
                bsSize="small"
                className="pull-right"
                bsStyle="success"
                type="submit"
                onClick={this.printDiv.bind(this)}
              >
                <i className="glyphicon glyphicon-print" /> Print
              </Button>
            </header>
            <div className="panel-body" id="DivIdToPrint">
              {!isEmpty(this.state.voucher) ? (
                <Row>
                  <Col md={12} xs={12}>
                   {!isEmpty(this.state.voucher.template)
                    ? ReactHtmlParser(this.state.voucher.template)
                    : ""}
                  </Col>
                </Row>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SampleVoucher.propTypes = {
  printSampleVoucher: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  error: state.frontReducer.error,
  voucherDetail: state.frontReducer.voucherDetail,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default compose(
  withRouter,
  connect(mapStateToProps, { printSampleVoucher, renderAlert, clearAlert })
)(SampleVoucher);




// WEBPACK FOOTER //
// ./src/app/views/merchant/voucher/SampleVoucher.js